import { showApiErrorNotification, useApiMutation } from '@vrplatform/data';
import type { ConfirmBankConnectionsData } from '../_components/add-bank-account-button/ConfirmBankConnectionsModal';
import { useCallback } from 'react';
import type { PlaidEnvironment } from '../_types';

export function usePlaidOnSuccessMutation({
  onSuccess,
}: {
  onSuccess: (args: ConfirmBankConnectionsData) => void;
}) {
  'use memo';

  const {
    mutateAsync: completeFlow,
    isPending: loading,
    error,
    reset,
  } = useApiMutation('put', '/plaid/connect');

  const mutate = useCallback(
    (code: string, environment: PlaidEnvironment, token: string) =>
      completeFlow({
        body: {
          code,
          token,
          environment,
          connectionId: undefined!,
        },
      })
        .then((res) => {
          onSuccess({
            connectionIds: [res.data.connectionId],
          });
        })
        .catch((err) => {
          console.error(err);
          showApiErrorNotification({
            error: err,
            title: 'Failed to connect to bank account',
            defaultMessage:
              'Failed to connect to bank account. Please try again and contact support if the issue persists.',
          });
        }),
    [completeFlow, onSuccess]
  );

  return { mutate, loading, error, reset };
}
